import L from 'leaflet';
import Q from 'q';

(function(L, Q, $) {

  var $self = this;
  $self.Coalitions      = $self.Coalitions      || {};
  $self.Coalitions.show = $self.Coalitions.show || {};

  $self.Coalitions.show.map = (function() {
    var pub = {};

    var map,
        MAPTILER_AT = 'Mj3QVQ0x7NaiLzIISEof';

    pub.init = function(params) {
      map = L.map('coalition-show-map');

      _renderMap();
      _fetchCoalitionData(params.coalitionId)
        .then(function(res) {
          _renderCoalition(res.points, res.shapes, params.coalitionId);
        });
    };

    function _fetchCoalitionData(coalitionId) {
      var deferred = Q.defer();
      $.getJSON('/api/v1/coalitions/'+coalitionId+'/geojson', function(res) {
        deferred.resolve({points:res.result.points, shapes: res.result.shapes});
      });
      return deferred.promise;
    }

    function _renderCoalition(point, shape, id) {
      _renderShape(shape, id);
    }

    function _renderShape(shape, id) {
      var shapeLayer = L.geoJson(shape);
      shapeLayer.addTo(map);
      shapeLayer.setStyle({weight: 1});
      let bounds;
      // hardcoding in Alaska bounds that will not throw off map
      if (id === 134) {
        const alaskaSW = L.latLng(51.2097, -179.1505);
        const alaskaNE = L.latLng(71.4410, -129.9795);
        bounds = L.latLngBounds(alaskaSW, alaskaNE);
      } else {
        bounds = shapeLayer.getBounds();
      }
      map.fitBounds(bounds);
    }

    function _renderMap() {
      L.tileLayer('https://api.maptiler.com/maps/0fba6182-f457-412e-9fa9-d7e0bb62c29c/{z}/{x}/{y}.png?key=Mj3QVQ0x7NaiLzIISEof', {
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 1,
        maxZoom: 18,
        attribution: "\u003ca href=\"https://www.maptiler.com/copyright/\" target=\"_blank\"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href=\"https://www.openstreetmap.org/copyright\" target=\"_blank\"\u003e\u0026copy; OpenStreetMap\u003c/a\u003e",
        crossOrigin: true
      }).addTo(map);
    }

    return pub;
  })();

}).call(CC, L, Q, $);
